<template>
  <div class="PaperSelect-container">
    <el-select
      v-model="value"
      ref="select"
      placeholder="请选择试卷，可输入关键字搜索"
      filterable
      clearable
      prefix-icon="el-icon-search"
      :filter-method="searchCourse"
      :disabled="disabled"
      :style="tcfstyle"
      @clear="clearSelect">
      <el-option :value="value" :label="changeLabel" style="height: auto;padding: 0;">
        <el-table
          :data="tableData"
          :show-header="false"
          :row-style="{cursor: 'pointer'}"
          @row-click="openDetails"
          style="width: 100%">
          <el-table-column
            label="试卷名称"
            min-width="100"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span><i class="el-icon-document-checked"></i> <b>{{scope.row.dName}}</b></span>
            </template>
          </el-table-column>
          <el-table-column
            label="试卷说明"
            width="180"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="color:#99a9bf">说明：</span>
              <span>{{scope.row.dRemark}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="添加时间"
            align="center"
            width="180"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span><i class="el-icon-time"></i> {{scope.row.dTime}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="创建人"
            align="center"
            width="140"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span><i class="el-icon-user"></i> {{scope.row.username}}</span>
            </template>
          </el-table-column>
<!--          <el-table-column-->
<!--            label="权限类型"-->
<!--            align="center"-->
<!--            width="180">-->
<!--            <template slot-scope="scope">-->
<!--              <span v-if="scope.row.dIspub===0">公开</span>-->
<!--              <span v-if="scope.row.dIspub===1">仅组织</span>-->
<!--              <span v-if="scope.row.dIspub===2">仅经销商</span>-->
<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>
      </el-option>
      <el-pagination
        v-if="total>0"
        style="padding:10px"
        background
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-select>
  </div>
</template>

<script>
import { getPaperById, getPaperList } from '@/api/work'

export default {
  name: 'PaperSelect',
  props: {
    oldPaperid: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tcfstyle: {
      type: String,
      default: 'width: 100%'
    },
    groupid: {
      type: Number
    },
    role: {
      type: Number
    },
    delid: {
      type: String
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 5,
      total: 0,
      filterText: '',
      value: '',
      changeLabel: ''
    }
  },
  created() {
    this.getData()
    if (this.oldPaperid !== null && this.oldPaperid !== '' && this.oldPaperid !== undefined) {
      getPaperById({ dPaperid: this.oldPaperid }).then(response => {
        this.value = response.data.dPaperid
        this.changeLabel = response.data.dName
        this.$emit('input', this.value)
      }).catch(() => {})
    }
  },
  methods: {
    getData() {
      this.loading = true
      const data = {
        content: this.filterText,
        page: this.currentPage,
        limit: this.pageSize,
        groupid: this.groupid,
        role: this.role,
        delid: this.delid
      }
      getPaperList(data).then(response => {
        this.loading = false
        this.tableData = response.data.data
        this.total = response.data.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    clearSelect() {
      this.filterText = ''
      this.value = ''
      this.changeLabel = ''
      this.$emit('input', null)
    },
    searchCourse(val) {
      this.filterText = val
      this.currentPage = 1
      this.getData()
    },
    openDetails(data) {
      this.value = data.dPaperid
      this.changeLabel = data.dName
      this.$emit('input', this.value)
      // this.$emit('setCourse', data)
      this.$refs.select.blur()
    }
  }
}
</script>
<style lang="scss" scoped>
  .PaperSelect-container{
    .el-table::before{
      height: 0!important;
    }
    .el-pagination{
      margin-top: 20px;
    }
  }
</style>
